import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Response', new Immutable.Map({})).set('Search', new Immutable.List([]))
	.set('GetCorridasAbiertas', new Immutable.List([]))
	.set('GetCriterios', new Immutable.List([]))
	.set('GetResultAssignment', new Immutable.List([]))
	.set('GetCauseNegation', new Immutable.List([]))
	.set('GetStateJustificacion', new Immutable.List([]))
	.set('Mail', new Immutable.Map({}))
	.set('Donataria', new Immutable.Map({}))

/* Types */

export const ACTION_GET_CORRIDAS_ABIERTAS = 'ACTION_GET_CORRIDAS_ABIERTAS'

export const ACTION_GET_CRITERIOS = 'ACTION_GET_CRITERIOS'

export const ACTION_GET_RESULT_ASSIGNMENT = 'ACTION_GET_RESULT_ASSIGNMENT'

export const ACTION_GET_CAUSE_NEGATION = 'ACTION_GET_CAUSE_NEGATION'

export const ACTION_GET_STATE_JUSTIFICACION = 'ACTION_GET_STATE_JUSTIFICACION'

export const ACTION_SEARCH_FILTER = 'ACTION_SEARCH_FILTER'

export const ACTION_UPDATE_ASSIGNMENT_FILTER = 'ACTION_UPDATE_ASSIGNMENT_FILTER'

export const ACTION_SET_VARIABLE_POPUP ='ACTION_SET_VARIABLE_POPUP'

export const ACTION_SEND_ASSIGNMENT_FILTER = 'ACTION_SEND_ASSIGNMENT_FILTER'

export const ACTION_GET_SET_FILTER = 'ACTION_GET_SET_FILTER'


/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_GET_CORRIDAS_ABIERTAS:
			return state.set('GetCorridasAbiertas', new Immutable.List(action.Obj))
		case ACTION_GET_CRITERIOS:
			return state.set('GetCriterios', new Immutable.List(action.Obj))
		case ACTION_GET_RESULT_ASSIGNMENT:
			return state.set('GetResultAssignment', new Immutable.List(action.Obj))
		case ACTION_GET_CAUSE_NEGATION:
			return state.set('GetCauseNegation', new Immutable.List(action.Obj))
		case ACTION_GET_STATE_JUSTIFICACION:
			return state.set('GetStateJustificacion', new Immutable.List(action.Obj))

		case ACTION_SET_VARIABLE_POPUP:
			return state.set('VariablePopUp', new Immutable.Map(action.Obj))

		case ACTION_SEARCH_FILTER:
			return state.set('Search', new Immutable.List(action.Obj))

		case ACTION_UPDATE_ASSIGNMENT_FILTER:
			return state.set('Response', new Immutable.Map(action.Obj))

		case ACTION_SEND_ASSIGNMENT_FILTER:
			return state.set('Mail', new Immutable.Map(action.Obj))

		case ACTION_GET_SET_FILTER:
			return state.set('Donataria', new Immutable.Map(action.Obj))


		default:
			return state;
	}
};

/* Action Creators */

export const getCorridasAbiertas = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getCorridasAbiertas',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_CORRIDAS_ABIERTAS, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getCriterios = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getCriterios',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_CRITERIOS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getResultAssignment = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getResultAssignment',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_RESULT_ASSIGNMENT, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getCauseNegation = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getCauseNegation',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_CAUSE_NEGATION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getStateJustificacion = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getStateJustificacion',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_STATE_JUSTIFICACION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const searchFilterAssignment = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		let formAux = Object.assign({}, form)
		delete formAux.dataFiltros

		return new ClientHttpRequest({
			service: 'api/searchFilterAssignment',
			method: "POST",
			data: {...formAux},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			dispatch({ type: ACTION_SEARCH_FILTER, Obj: response.data })

			return response.data;
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateFilterAssignment = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		let formAux = Object.assign({}, form)
		delete formAux.dataFiltros

		return new ClientHttpRequest({
			service: 'api/updateFilterAssignment',
			method: "POST",
			data: {...formAux},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			dispatch({ type: ACTION_UPDATE_ASSIGNMENT_FILTER, Obj: response.data })
			return true
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const setVaribleToPopUp = (data) => {

	return (dispatch) => {
		dispatch({ type: ACTION_SET_VARIABLE_POPUP, Obj: data })
		return data

	}
}

export const sendMailFilterAssignment = (form) => {
	delete form.dataFiltros
	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/sendMailFilterAssignment',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token,  "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse('Hubo un error al activar la evaluación'))))
			//dispatch({ type: ACTION_SEND_ASSIGNMENT_FILTER, Obj: response.data })
			return true
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}

}

export const getSetDonataria = (form) => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_SET_FILTER, Obj: form })
		let promise = new Promise(function(resolve) {
			resolve(form);
		})
		return promise
	}
}



// WEBPACK FOOTER //
// ./src/modules/Filter/AssignmentFilter.js